module.exports = __webpack_public_path__ + "static/media/bike transport call icon.5e982421.png";